import { computed } from 'vue';

export function useBuildingDetails(bedrijfspand) {
  const buildingTypeValues = {
    'Bedrijfshal (excl. kantoor)': {
      luxuryConstructionPrice: 1500,
      minimumConstructionPrice: 900,
    },
    'Kantoorpand': {
      luxuryConstructionPrice: 2200,
      minimumConstructionPrice: 1650,
    },
    'Winkel / toonzaal': {
      luxuryConstructionPrice: 1925,
      minimumConstructionPrice: 1375,
    },
    'Horecapand': {
      luxuryConstructionPrice: 2200,
      minimumConstructionPrice: 1760,
    },
    'Gezonheidscentrum': {
      luxuryConstructionPrice: 2475,
      minimumConstructionPrice: 1925,
    },
    'Hotel': {
      luxuryConstructionPrice: 1925,
      minimumConstructionPrice: 1375,
    },
    'School': {
      luxuryConstructionPrice: 2200,
      minimumConstructionPrice: 1650,
    },
    'Sportcomplex': {
      luxuryConstructionPrice: 2650,
      minimumConstructionPrice: 2200,
    },
  };
  const buildingRebuildValue = computed(() => {
    const { bouwaard, oppervlakte, gebouwtypeMinimaleM2Waarde, gebouwtypeLuxeM2Waarde } = bedrijfspand;

    if (!bouwaard || !oppervlakte || !gebouwtypeMinimaleM2Waarde || !gebouwtypeLuxeM2Waarde) {
      return 0;
    }

    const squareMeterPrice = bouwaard === 'luxe' ? gebouwtypeLuxeM2Waarde : gebouwtypeMinimaleM2Waarde;

    return squareMeterPrice * oppervlakte;
  });

  return {
    buildingTypeValues,
    buildingRebuildValue,
  };
}
